import Vue from 'vue';
import VueRouter from 'vue-router';
import beforeResolve from '@/router/beforeResolve';
import beforeEach from '@/router/beforeEach';
import afterEach from '@/router/afterEach';
import NavigationGroup from '@/models/navigationGroup';
import Login from '@/views/Login.vue';
import Home from '@/views/Home.vue';
import MyUnavailability from '@/views/MyUnavailability.vue';
import ViewJob from '@/views/ViewJob.vue';
import ViewJobTake5Safety from '@/views/ViewJobTake5Safety.vue';
import ViewJobStatus from '@/views/ViewJobStatus.vue';
import ViewJobServiceForm from '@/views/ViewJobServiceForm.vue';
import ViewJobNotes from '@/views/ViewJobNotes.vue';
import ViewJobSafetyDocs from '@/views/ViewJobSafetyDocs.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      noAuth: true
    }
  },
  {
    path: '/logout',
    name: 'logout',
    meta: {
      noNav: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      navigationTitle: "Home"
    }
  },
  {
    path: '/myunavailability',
    name: 'myunavailability',
    component: MyUnavailability,
    meta: {
      navigationTitle: "My Unavailability",
      navigationGroup: "Technician"
    }
  },
  {
    path: '/job/:jobID',
    name: 'viewjob',
    component: ViewJob,
    meta: {
      
    }
  },
  {
    path: '/job/:jobID/status',
    name: 'viewjobstatus',
    component: ViewJobStatus,
    meta: {
      
    }
  },
  {
    path: '/job/:jobID/serviceForm',
    name: 'viewjobserviceform',
    component: ViewJobServiceForm,
    meta: {
      
    }
  },
  {
    path: '/job/:jobID/notes',
    name: 'viewjobnotes',
    component: ViewJobNotes,
    meta: {
      
    }
  },
  {
    path: '/job/:jobID/safetyDocs',
    name: 'viewjobsafetydocs',
    component: ViewJobSafetyDocs,
    meta: {
      
    }
  },
  {
    path: '/job/:jobID/take5',
    name: 'viewjobtake5',
    component: ViewJobTake5Safety,
    meta: {
      
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve(beforeResolve);
router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router;

const navigationGroups: NavigationGroup[] = [];
routes.forEach((r): void => {
  if(r.meta == null || r.meta.navigationTitle == null){
    return;
  }

  let groupName = r.meta.navigationGroup || "";

  let navigationGroup = navigationGroups.find((x): boolean => x.groupName == groupName);
  if(navigationGroup == null){
    navigationGroup = {
      groupName: groupName,
      routes: []
    };
    navigationGroups.push(navigationGroup);
  }

  navigationGroup.routes.push({
    routeName: r.name,
    navigationTitle: r.meta.navigationTitle
  });
});

export { navigationGroups };